import React from 'react'

import { Box, Card, Grid, Text } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
  info?: string
  contentTitle: string
  averageTitle: string
  content?: string
  averageContent?: string
}

export const AverageChart = ({
  title,
  contentTitle,
  averageTitle,
  content,
  averageContent,
  info,
}: React.PropsWithChildren<Props>) => (
  <Card>
    <Card.Title tooltip={info}>{title}</Card.Title>
    <Card.Content>
      <Grid variant="fixed">
        <Box gridColSpan={{ xxs: 6 }} gap="s8">
          <Text size="200" weight="medium">
            {contentTitle}
          </Text>
          <Text size="600" weight="medium" color="grey1000">
            {content}
          </Text>
        </Box>
        <Box gridColSpan={{ xxs: 6 }} gap="s8">
          <Text size="200" weight="medium">
            {averageTitle}
          </Text>
          <Text size="600" weight="medium" color="grey1000">
            {averageContent}
          </Text>
        </Box>
      </Grid>
    </Card.Content>
  </Card>
)
